import { Grid, Paper } from '@mui/material';
import { DeleteConfirmationModal } from 'components/delete-confirmation';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CreateSettingModal } from './components/Create-setting-modal';
import { Header } from './components/Header';
import { LoaderNotes } from './components/LoaderNotes';

import { useChargeSettingsHooks } from './hooks';
import { SettingsTable } from './SettingsTable';
import { useStyles } from './styles';

export const ChargeSettings = () => {
  const { t } = useTranslation();
  const {
    isLoading,
    settingsPages,
    rowsPerPage,
    totalPages,
    totalRows,
    currentPage,
    setCurrentPage,
    changeRowsPerPage,
    modalData,
    setModalData,
    isDeleteLoading,
    onCloseModal,
    deleteSetting,
    createSettingMutation,
    updateSettingMutation,
    isCreateLoading,
    isUpdateLoading
  } = useChargeSettingsHooks();
  const classes = useStyles();

  return (
    <>
      <Grid
        container
        className={classes.container}
      >
        <Grid item xs={12} className={classes.item}>
          <Header handleModalOpen={() => setModalData({ modal: "createSetting" })} />
        </Grid>

        <Grid item xs={12} className={classes.item}>
          <Paper className={classes.paperContainer}>
            {isLoading && <LoaderNotes />}
            <SettingsTable
              settingsPages={settingsPages}
              rowsPerPage={rowsPerPage}
              totalPages={totalPages}
              totalRows={totalRows}
              isDataLoading={isLoading}
              changeRowsPerPage={changeRowsPerPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              onDeleteSetting={(settingId) => setModalData({ modal: "deleteSetting", settingId })}
              onEditSetting={(setting) => setModalData({ modal: "editSetting", setting })}
            />
          </Paper>
        </Grid>
      </Grid>

      {modalData?.modal === 'deleteSetting' && (
        <DeleteConfirmationModal
          isOpen
          title={t('common:delete-setting')}
          confirmationMessage={t('common:delete-setting-confirm')}
          onClose={onCloseModal}
          onConfirm={deleteSetting}
          isRemoveLoading={isDeleteLoading}
          buttonConfirmText={t('common:delete')}
        />
      )}

      {(modalData?.modal === "createSetting" || modalData?.modal === "editSetting") && (
        <CreateSettingModal
          isCreateLoading={isCreateLoading}
          isUpdateLoading={isUpdateLoading}
          onClose={onCloseModal}
          prevSettingData={modalData.modal === "editSetting" ? modalData.setting : undefined}
          onCreate={createSettingMutation}
          onUpdate={updateSettingMutation}
        />
      )}
    </>
  );
};
